import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";
import { calculateTotalExperienceDuration } from "../../../utils/calculateDatesDifference";

export default function CommonPdfHeader( { resumeData, translations } ) {

    const { logoSrc, logoLabel, isAlcyone } = extractResumeProperties( resumeData );
    const { totalExperienceDuration, experiences } = extractResumeDataDocumentSection( resumeData );

    const {
        years: experienceYears,
        months: experienceMonths,
    } = calculateTotalExperienceDuration( experiences, totalExperienceDuration );

    const isLusis = ( logoLabel || "" ).toLowerCase().includes( "lusis" )
        || ( logoSrc || "" ).toLowerCase().includes( "lusis" );
    const headerTop = isAlcyone ? '20px' : '60px';
    const experienceMarginTop = isAlcyone ? 18 : 40;
    const logoMarginTop = isAlcyone ? '-4px' : '0px';

    const styles = StyleSheet.create( {
        header: {
            width: '240px',
            alignSelf: 'flex-end',
            position: 'absolute',
            top: headerTop,
            right: '40px',
        },
        imageHeight: {
            width: '60px',
            objectFit: 'cover',
            alignSelf: 'flex-end',
            marginTop: logoMarginTop,
            marginBottom: '6px',
        },
        experience: {
            textAlign: 'right',
            color: '#808080',
            fontSize: '8pt',
            marginTop: experienceMarginTop,
        },
    } );

    const imageStyle = isLusis
        ? { ...styles.imageHeight, height: '75px', width: undefined }
        : styles.imageHeight;

    return (
        <View style={ styles.header } fixed>
            <Image style={ imageStyle } src={ logoSrc }/>
            <Text style={ styles.experience }>
                { translations.pdf.workExperienceLabel }{ ' ' }
                { translations.pdf.workExperienceTemplate
                    .replace( "{years}", experienceYears )
                    .replace( "{months}", experienceMonths ) }
            </Text>
        </View>
    );
}
